import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import IconButton from '@mui/material/IconButton';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import DownloadIcon from '@mui/icons-material/ZoomIn';
import {saveAs} from 'file-saver';
import { extendedstyles } from '../../appstyles';
import { Box } from '@mui/material';

const s:any ={
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    // overflow: 'hidden',
    flex: '1 1 auto',
    background: 'background.paper',
  },
  imageList: {
    width: 800,
    height: 350,
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  imageListItem: {
    
  },
  gridTileImage: {
    flex: '1 1 auto'
  },
  titleBar: {
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  icon: {
    color: 'white',
  },
};

class VeriPane extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      count:0
    };
  }

  handleClick = (name:any) => (event:any,value:any) => {
    var {result} = this.props;
    console.log('result',result,value,name);
    var blob = new Blob(value);
    saveAs(blob);
  } 

  render() {
    const { record,photo,idcard,classes} = this.props;
    ///console.log('vpane.record,',record);
    //const photo card;
    return (
      <Box sx={{...s.root}}>
        {/* <ImageList rowHeight={300} spacing={1} sx={{...s.imageList}}> */}
        <ImageList rowHeight={350} gap={1} sx={{...s.imageList}}>
          <ImageListItem cols={1} rows={1} sx={{...s.imageListItem}}>
            <Box component='img' id={photo.resid} src={photo.src} alt="" sx={{...s.gridTileImage}}/>
            <ImageListItemBar
              title={photo.title}
              position="top"
              actionIcon={
                <IconButton sx={{...s.icon}}>
                  <DownloadIcon />
                </IconButton>
              }
              actionPosition="right"
              sx={{...s.titleBar}}
            />
          </ImageListItem>
          <ImageListItem key={idcard.resid} cols={1} rows={1} sx={{...s.imageListItem}}>
            <Box component='img' id={idcard.resid} src={idcard.src} alt="" sx={{...s.gridTileImage}}/>

            <ImageListItemBar
              title={idcard.title}
              position="top"
              actionIcon={
                <IconButton sx={{...s.icon}}>
                  <DownloadIcon />
                </IconButton>
              }
              actionPosition="right"
              sx={{...s.titleBar}}
            />
          </ImageListItem>
    
        </ImageList>
      </Box>
    );
  }
}

VeriPane.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default VeriPane;
